import parse from 'html-react-parser';
import React, { useContext } from 'react';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { NotesContext } from '../../contexts/NotesContext';
import { TabsContainer, TabsWrapper, TabsTitlesWrapper, CustomTab, TabPanel } from './styles';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface TabContentProps {
  tabs: { title: string; subtitle?: string; content: string }[];
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <TabPanel>
          {children}
        </TabPanel>
      )}
    </div>
  );
}

export default function TabContent({ tabs }: TabContentProps) {
  const [value, setValue] = React.useState(0);
  const { replace } = useContext(NotesContext);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function TabProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }

  return (
    <TabsWrapper>
      <TabsContainer $color={20} $subject="portuguese">
        <TabsTitlesWrapper $color={50} $subject="portuguese">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="visible arrows tabs"
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            {tabs.map((tab, index) => (
              <CustomTab
                key={index}
                label={tab.title}
                id={TabProps(index).id}
                aria-controls={TabProps(index)['aria-controls']}
              />
          ))}
          </Tabs>
        </TabsTitlesWrapper>
        {tabs.map((tab, index) => (
          <>
            <CustomTabPanel key={index} value={value} index={index}>
              {tab.subtitle && <Typography variant="h5" sx={{ padding: 0 }}>{parse(tab.subtitle, { replace })}</Typography>}
              {parse(tab.content, { replace })}
            </CustomTabPanel>
          </>
          ))}
      </TabsContainer>
    </TabsWrapper>
  );
}
